import { useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom"

import { getCountry, getProfessional, getSpeciality, register, validateEmail } from '../../lib/api';
import Button from '../UI/Button';
import Input from '../UI/Input';
import Dropdown from '../UI/Dropdown';
import useInput from '../../hooks/use-input';
import { isFirstName, isLastName, isInstitution, isPassword } from '../UI/Validations';

const isNotEmpty = (value) => value.trim() !== '';

const HealthCareRegister = ({ setIsLoading, isLoading }) => {
    const history = useHistory();
    const [isChecked, setIsChecked] = useState(false)
    const [unCheckedError, setUnCheckedError] = useState('');
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [unTermsError, setUnTermsError] = useState('');
    const [isEmailExist, setIsEmailExist] = useState(false);
    const [emailValue, setEmailHasValue] = useState();
    const [emailHasError, setEmailhasError] = useState();
    const [emailHasEmptyError, setEmailHasEmptyError] = useState(false);
    const [selectedProfessionalOption, setSelectedProfessionalOption] = useState(null);
    const [selectedSpecialityOption, setSelectedSpecialityOption] = useState(null);
    const [isProfessionalValid, setProfessionalValid] = useState(true);
    const [isSpecialityValid, setSpecialityIsValid] = useState(true);
    const [professionalOptionsList, setProfessionalOptionsList] = useState([]);
    const [specialityOptionsList, setSpecialityOptionsList] = useState([]);
    const [specialityMessage, setSpecialityMessage] = useState("");
    const [professionHasError, setProfessionHasError] = useState();
    const [selectedCountryOption, setSelectedCountryOption] = useState(null);
    const [isCountryValid, setCountryValid] = useState(false);
    const [countryOptionsList, setCountryOptionsList] = useState([]);
    const [countryHasError, setCountryHasError] = useState();

    const handleProfessionalOption = (option) => {
        setSpecialityOptionsList(null);
        setSelectedSpecialityOption(null);
        setSelectedProfessionalOption(option);
        setProfessionalValid(true);
        setProfessionHasError() // Reset validation when an option is selected   
        setSpecialityIsValid(false);
        specialitysendRequest(option.id);
        setIsLoading(true);
        setSpecialityMessage("Please select your speciality.");
    };

    const handleSpecialityOption = (option) => {
        setSelectedSpecialityOption(option);
        setSpecialityIsValid(true); // Reset validation when an option is selected
    };

    const handleBlur = (dropdownNumber, isValid) => {
        if (dropdownNumber === 1) {
            setProfessionalValid(isValid);
            setProfessionHasError("Please select your profession.") // Update the validation state for dropdown 1
        } else if (dropdownNumber === 2) {
            setSpecialityIsValid(isValid); // Update the validation state for dropdown 2
        }
    };

    const handleEmailValidate = () => {
        validateEmail(emailInputRef?.current?.value)
            .then((response) => {
                if (response.length > 0) {
                    return setIsEmailExist(true)
                }
                else return setIsEmailExist(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const emailValidation = (value) => {
        if (!value) { setEmailHasEmptyError(false); setEmailhasError("Please enter email") }
        else if (value[0] === ' ') { setEmailHasEmptyError(false); setEmailhasError("Email cannot start with space") }
        else if (!value.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) { setEmailHasEmptyError(false); setEmailhasError("Please enter valid email") }
        else { handleEmailValidate(); setEmailHasEmptyError(true); setEmailhasError('') }
        setEmailHasValue(value.replace(/\s/g, ''))
    }

    const handleEmailChange = (e) => {
        e.preventDefault();
        setIsEmailExist(false)
        let { id, value } = e.target;
        if (id === "email") {
            emailValidation(value)
        }
    }

    const handleEmailBlur = (e) => {
        e.preventDefault();
        let { id, value } = e.target;
        if (id === "email") {
            emailValidation(value)
        }
    }

    const handleCountryOption = (option) => {
        setSelectedCountryOption(option);
        setCountryValid(true);
        setCountryHasError()
    };

    const handleBlurCountry = (isValid) => {
        // setCountryValid(isValid);
        setCountryHasError("Please select your country.")
    };

    const countrysendRequest = () => {
        getCountry()
            .then((response) => {
                const options = response?.data.map((details) => ({
                    id: details.id,
                    value: details.country_name,
                }));
                setCountryOptionsList(options);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const titleInputRef = useRef();
    const firstNameInputRef = useRef();
    const lastNameInputRef = useRef();
    const institutionNameInputRef = useRef();
    const emailInputRef = useRef();
    const createPasswordInputRef = useRef();
    const confirmPasswordInputRef = useRef();

    const {
        value: titleValue,
        valueChangeHandler: titleChangeHandler,
        inputBlurHandler: titleBlurHandler,
    } = useInput(isNotEmpty);

    const {
        value: firstNameValue,
        isValid: firstNameIsValid,
        hasError: firstNameHasError,
        valueChangeHandler: firstNameChangeHandler,
        inputBlurHandler: firstNameBlurHandler,
    } = useInput(isFirstName);

    const {
        value: lastNameValue,
        isValid: lastNameIsValid,
        hasError: lastNameHasError,
        valueChangeHandler: lastNameChangeHandler,
        inputBlurHandler: lastNameBlurHandler,
    } = useInput(isLastName);

    const {
        value: institutionNameValue,
        isValid: institutionNameIsValid,
        hasError: institutionNameHasError,
        valueChangeHandler: institutionNameChangeHandler,
        inputBlurHandler: institutionNameBlurHandler,
    } = useInput(isInstitution);

    const {
        value: createPasswordValue,
        isValid: createPasswordIsValid,
        hasError: createPasswordHasError,
        valueChangeHandler: createPasswordChangeHandler,
        inputBlurHandler: createPasswordBlurHandler,
    } = useInput(isPassword);

    const {
        value: confirmPasswordValue,
        isValid: confirmPasswordIsValid,
        hasError: confirmPasswordHasError,
        valueChangeHandler: confirmPasswordChangeHandler,
        inputBlurHandler: confirmPasswordBlurHandler,
    } = useInput(isPassword, createPasswordValue);

    let formIsValid = false;

    if (
        !firstNameIsValid &&
        !lastNameIsValid &&
        isProfessionalValid &&
        isSpecialityValid &&
        !institutionNameIsValid &&
        emailHasEmptyError &&
        !isEmailExist &&
        isChecked &&
        !createPasswordIsValid &&
        !confirmPasswordIsValid &&
        isCountryValid
    ) {
        formIsValid = true
    }

    const handleCheckbox = (event) => {
        setIsChecked(event.target.checked)
        if (!event.target.checked) {
            setUnCheckedError('Please check the checkbox to proceed further');
        } else setUnCheckedError('')
    }

    const handleTermsCheckbox = (event) => {
        setIsTermsChecked(event.target.checked)
        if (!event.target.checked) {
            setUnTermsError('Please check the checkbox to proceed further');
        } else setUnTermsError('')
    }

    const healthcareProfessional = (event) => {
        event.preventDefault();

        if (!formIsValid) {
            return;
        }

        setIsLoading(true);

        const enteredTitle = titleInputRef.current.value;
        const enteredFirstname = firstNameInputRef.current.value;
        const enteredLastname = lastNameInputRef.current.value;
        const enteredInstitutionName = institutionNameInputRef.current.value;
        const enteredEmail = emailInputRef.current.value;
        const enteredPassword = createPasswordInputRef.current.value;

        const formData = {
            name: {
                value: enteredEmail
            },
            mail: {
                value: enteredEmail
            },
            pass: {
                value: enteredPassword
            },
            field_name_title: {
                value: enteredTitle
            },
            field_first_name: {
                value: enteredFirstname
            },
            field_last_name: {
                value: enteredLastname
            },
            field_institution_name: {
                value: enteredInstitutionName
            },
            field_profession: {
                value: selectedProfessionalOption.id
            },
            field_specialty: {
                value: selectedSpecialityOption.id
            },
            field_user_type: {
                value: "1"
            },
            field_country: {
                value: selectedCountryOption.value,
            },
        }
        register(formData)
            .then(async (res) => {
                setIsLoading(false);
                if (res.uid.length > 0) {
                    history.push('/registerConfirmation')
                }
            })
            .catch((error) => {
                setIsLoading(false);
            })
    }

    useEffect(() => {
        professionalsendRequest();
        countrysendRequest()
    }, [])

    const specialitysendRequest = (profession_id) => {
        getSpeciality(profession_id)
            .then((response) => {
                const options = response.map((details) => ({
                    id: details.tid,
                    value: details.name,
                }));
                setSpecialityOptionsList(options);
                if (options.length === 0) {
                    setSpecialityMessage("No speciality found for selected profession!");
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error);
            });
    };

    const professionalsendRequest = () => {
        getProfessional()
            .then((response) => {
                const options = response.map((details) => ({
                    id: details.tid,
                    value: details.name,
                }));
                setProfessionalOptionsList(options);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleTermsandService = () => {
        window.open("/linkdetail/terms-service", "_blank");
    }

    const handlePrivacyPolicy = () => {
        window.open("/linkdetail/privacy-statement", "_blank");
    }

    const handleOrganizationMessage = () => {
        window.open("/linkdetail/messages-organization", "_blank");
    }

    const handleCookiesPolicy = () => {
        window.open("/linkdetail/cookie-policy", "_blank");
    }


    const firstNameClasses = firstNameIsValid
        ? "nameSection gap-1 flex flex-col invalid grow"
        : "nameSection gap-1 flex flex-col";
    const lastNameClasses = lastNameIsValid
        ? "nameSection gap-1 flex flex-col invalid grow"
        : "nameSection gap-1 flex flex-col";
    const institutionClasses = institutionNameIsValid
        ? "institutionSection gap-1 flex flex-col invalid"
        : "institutionSection gap-1 flex flex-col";
    const emailClasses = (!emailHasEmptyError || isEmailExist)
        ? "emailSection gap-1 flex flex-col invalid"
        : "emailSection gap-1 flex flex-col";
    const passwordClasses = (createPasswordIsValid)
        ? "passwordSection gap-1 flex flex-col invalid"
        : "passwordSection gap-1 flex flex-col";
    const confirmPasswordClasses = confirmPasswordHasError
        ? "confirmPasswordSection gap-1 flex flex-col invalid"
        : "confirmPasswordSection gap-1 flex flex-col";

    return (
        <>
            <div className="tabContentHolder">
                <div className="tabContentOne">
                    <p className="text-[#333] text-sm leading-5 md:text-base  font-normal max-w-[75%] sm:max-w-[50%]  block md:hidden mt-4">Click here to register if you are a Healthcare Professional.</p>
                    <div className="mt-4 sm:mt-11">
                        <div className="flex items-center gap-[90px]">
                            <div className="formHolder basis-full lg:basis-[70%] shrink-0">
                                <form className="registerForm customer space-y-6 *:flex-wrap sm:*:flex-nowrap" onSubmit={healthcareProfessional}>
                                    <div className="flex items-start gap-x-12 gap-y-6 *:grow *:shrink names *:basis-full sm:basis-1/2">
                                        <div className="flex flex-col sm:flex-row gap-6 sm:gap-5">
                                            <div className="titleSection gap-1 flex flex-col basis-full sm:basis-[120px] lg:basis-1/4 lg:grow xl:grow-0">
                                                <Input
                                                    ref={titleInputRef}
                                                    label="Title"
                                                    labelClass="firstNameLabel text-[#333] text-sm font-normal leading-5"
                                                    input={{
                                                        id: "title",
                                                        name: "title",
                                                        type: "text",
                                                        value: titleValue,
                                                        placeholder: "Mr/Ms/Mrs",
                                                        onChange: titleChangeHandler,
                                                        onBlur: titleBlurHandler,
                                                        className:
                                                            "p-[10px] w-full rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666] !text-[#333]",
                                                    }}
                                                />
                                            </div>
                                            <div className={firstNameClasses}>
                                                <Input
                                                    ref={firstNameInputRef}
                                                    label="First Name"
                                                    labelClass="firstNameLabel text-[#333] text-sm font-normal leading-5"
                                                    isManditory={true}
                                                    input={{
                                                        id: "firstName",
                                                        name: "firstName",
                                                        type: "text",
                                                        value: firstNameValue,
                                                        placeholder: "Enter First Name",
                                                        onChange: firstNameChangeHandler,
                                                        onBlur: firstNameBlurHandler,
                                                        className:
                                                            "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  text-sm",
                                                    }}
                                                />
                                                {firstNameHasError && (
                                                    <p className="error-text">
                                                        {firstNameIsValid}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                        <div className={lastNameClasses}>
                                            <Input
                                                ref={lastNameInputRef}
                                                label="Last Name"
                                                labelClass="lastNameLabel text-[#333] text-sm font-normal leading-5"
                                                isManditory={true}
                                                input={{
                                                    id: "lastName",
                                                    name: "lastName",
                                                    type: "text",
                                                    value: lastNameValue,
                                                    placeholder: "Enter Last Name",
                                                    onChange: lastNameChangeHandler,
                                                    onBlur: lastNameBlurHandler,
                                                    className:
                                                        "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  text-sm",
                                                }}
                                            />
                                            {lastNameHasError && (
                                                <p className="error-text">
                                                    {lastNameIsValid}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-x-12 gap-y-6 *:grow *:shrink professonSpeciality *:basis-full sm:basis-1/2">
                                        <div className="professionSection gap-1 flex flex-col relative">
                                            <Dropdown
                                                label="Profession"
                                                labelClass="professtionLabel text-[#333] text-sm font-normal leading-5"
                                                placeholder="Select a Profession"
                                                isManditory={true}
                                                options={professionalOptionsList}
                                                onSelect={handleProfessionalOption}
                                                onBlur={(isValid) => handleBlur(1, isValid)}
                                                isValid={isProfessionalValid} // Pass validation state for dropdown 1
                                                selectedValue={selectedProfessionalOption}
                                            />

                                            {(!isProfessionalValid && professionHasError) && (
                                                <p className="error-text">
                                                    {professionHasError}
                                                </p>
                                            )}
                                        </div>
                                        <div className="specialitySection gap-1 flex flex-col relative">
                                            <Dropdown
                                                label="Speciality"
                                                labelClass="specialityLabel text-[#333] text-sm font-normal leading-5"
                                                placeholder="Select a Speciality"
                                                isManditory={true}
                                                options={specialityOptionsList}
                                                onSelect={handleSpecialityOption}
                                                onBlur={(isValid) => handleBlur(2, isValid)}
                                                isValid={isSpecialityValid}
                                                selectedValue={selectedSpecialityOption}
                                            />

                                            {!isSpecialityValid && (
                                                <p className="error-text">
                                                    {specialityMessage}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-x-12 gap-y-6 *:grow *:shrink instNames *:basis-full sm:basis-1/2">
                                        <div className={institutionClasses}>
                                            <Input
                                                ref={institutionNameInputRef}
                                                label="Institution Name"
                                                labelClass="firstNameLabel text-[#333] text-sm font-normal leading-5"
                                                isManditory={true}
                                                input={{
                                                    id: "institution",
                                                    name: "institution",
                                                    type: "text",
                                                    value: institutionNameValue,
                                                    placeholder: "Enter Institution Name",
                                                    onChange: institutionNameChangeHandler,
                                                    onBlur: institutionNameBlurHandler,
                                                    className:
                                                        "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
                                                }}
                                            />
                                            {institutionNameHasError && (
                                                <p className="error-text">
                                                    {institutionNameIsValid}
                                                </p>
                                            )}
                                        </div>
                                        {/* <div className="nameSection gap-[6px]  flex-col sm:invisible hidden sm:block">
                                            <label className="titleLabel text-[#333] text-sm font-normal leading-5">dummy</label>
                                            <input type="text" className="p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 placeholder:text-[#666] text-sm " placeholder="dummy" />
                                        </div> */}
                                        <div className="countrySection gap-[6px] flex flex-col relative">
                                            <Dropdown
                                                label="Country"
                                                labelClass="countryLabel text-[#333] text-sm font-normal leading-5"
                                                placeholder="Select a Country"
                                                isManditory={true}
                                                options={countryOptionsList}
                                                onSelect={handleCountryOption}
                                                onBlur={(isValid) => handleBlurCountry(isValid)}
                                                isValid={isCountryValid} // Pass validation state for dropdown 1
                                                selectedValue={selectedCountryOption}
                                                type={'country'}
                                            />
                                            {(!isCountryValid && countryHasError) && (
                                                <p className="error-text">
                                                    {countryHasError}
                                                </p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-x-12 gap-y-6 *:grow *:shrink emailSections *:basis-full sm:basis-1/2">
                                        <div className={emailClasses}>
                                            <Input
                                                ref={emailInputRef}
                                                label="Email"
                                                labelClass="emailNameLabel text-[#333] text-sm font-normal leading-5"
                                                isManditory={true}
                                                input={{
                                                    id: "email",
                                                    name: "email",
                                                    type: "text",
                                                    value: emailValue,
                                                    placeholder: "Enter Your Email",
                                                    onChange: (e) => handleEmailChange(e),
                                                    onBlur: (e) => handleEmailBlur(e),
                                                    className:
                                                        "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
                                                }}
                                            />
                                            {!emailHasEmptyError && (
                                                <p className="error-text">
                                                    {emailHasError}
                                                </p>
                                            )}
                                            {(isEmailExist) && (
                                                <p className='error-text'>
                                                    This Email is already taken. Please try with another email.
                                                </p>
                                            )}
                                        </div>
                                        <div className="emailSection gap-[6px] flex-col sm:invisible hidden sm:block">
                                            <label className="emailLabel text-[#333] text-sm font-normal leading-5">dummy</label>
                                            <input type="text" className="p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 placeholder:text-[#666] text-sm" placeholder="dummy" />
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-x-12 gap-y-6 *:grow *:shrink professonSpeciality *:basis-full sm:basis-1/2">
                                        <div className={passwordClasses}>
                                            <Input
                                                ref={createPasswordInputRef}
                                                label="Password"
                                                labelClass="passwordLabel text-[#333] text-sm font-normal leading-5"
                                                isManditory={true}
                                                input={{
                                                    id: "password",
                                                    name: "password",
                                                    type: "password",
                                                    value: createPasswordValue,
                                                    placeholder: "Create Password",
                                                    onChange: createPasswordChangeHandler,
                                                    onBlur: createPasswordBlurHandler,
                                                    className:
                                                        "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
                                                }}
                                            />
                                            {createPasswordHasError && (
                                                <p className="error-text">
                                                    {createPasswordIsValid}
                                                </p>
                                            )}
                                        </div>
                                        <div className={confirmPasswordClasses}>
                                            <Input
                                                ref={confirmPasswordInputRef}
                                                label="Confirm Password"
                                                labelClass="confirmPasswordLabel text-[#333] text-sm font-normal leading-5"
                                                isManditory={true}
                                                input={{
                                                    id: "confirmPassword",
                                                    name: "confirmPassword",
                                                    type: "password",
                                                    value: confirmPasswordValue,
                                                    placeholder: "Enter Confirm Password",
                                                    onChange: confirmPasswordChangeHandler,
                                                    onBlur: confirmPasswordBlurHandler,
                                                    className:
                                                        "p-[10px] rounded border border-loginFieldBorder text-[#666] h-10 !text-sm placeholder:text-[#666]  !text-[#333]",
                                                }}
                                            />
                                            {confirmPasswordHasError && (
                                                <p className="error-text">Passwords do NOT match!</p>
                                            )}
                                        </div>
                                    </div>
                                    <div className="accountCreationAccpect">
                                        <div className="flex gap-3 items-start">
                                            <input
                                                type="checkbox"
                                                className="size-5 rounded-lg shrink-0 border-2 border-loginFieldBorder mt-1"
                                                onChange={(event) => handleCheckbox(event)} />
                                            <p className="text-[#333] leading-normal font-normal text-base">I permit The Source to send me updates from its personalized alerts and <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={handleOrganizationMessage}>Messages from organization.</span></p>
                                        </div>
                                        {!isChecked && unCheckedError && (<p className="error-text mt-1">{unCheckedError}</p>)}
                                        <div className="flex gap-3 items-start mt-2">
                                            <input
                                                type="checkbox"
                                                className="size-5 rounded-lg shrink-0 border-2 border-loginFieldBorder mt-1"
                                                onChange={(event) => handleTermsCheckbox(event)} />
                                            <div className='flex flex-col items-start'>
                                                <p className="text-[#333] leading-normal font-normal text-sm sm:text-base">
                                                    I agree to the <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={handleTermsandService} >Terms of Service</span>
                                                </p>
                                                <p className="text-[#333] leading-normal font-normal text-sm sm:text-base">
                                                    Learn how we collect, use and share your data in our <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={handlePrivacyPolicy} >Privacy Statement</span> and how we use cookies in our <span className="text-primaryBlue leading-5 font-normal text-sm cursor-pointer" onClick={handleCookiesPolicy} >Cookie Policy.</span>
                                                </p>
                                            </div>
                                        </div>
                                        {!isTermsChecked && unTermsError && <p className="error-text mt-1">{unTermsError}</p>}
                                        {!isLoading && (
                                            <Button
                                                disabled={!formIsValid}
                                                type="submit"
                                                className={!formIsValid ? "btn mt-8 continueBtn w-auto bg-primaryBlue h-[46px] px-20 py-[10px] font-bold leading-5 text-base justify-center  rounded text-white inline-flex items-center disabled" : "btn mt-8 continueBtn w-auto bg-primaryBlue h-[46px] px-20 py-[10px] font-bold leading-5 text-base justify-center  rounded text-white inline-flex items-center cursor-pointer"}
                                            >
                                                Continue
                                            </Button>
                                        )}
                                    </div>
                                </form>
                            </div>
                            <div className="videoSection !hidden lg:flex lg:basis-[420px] shrink grow">
                                <div className="videoHolder aspect-video w-full">
                                    <video src="../src/videos/video.mp4" className="h-full" controls muted></video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default HealthCareRegister